import { render } from "./sales-rep-performance-table.vue?vue&type=template&id=6bb7dfa2&scoped=true"
import script from "./sales-rep-performance-table.vue?vue&type=script&lang=js"
export * from "./sales-rep-performance-table.vue?vue&type=script&lang=js"

import "./sales-rep-performance-table.vue?vue&type=style&index=0&id=6bb7dfa2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb7dfa2"]])

export default __exports__